import Vue from 'vue'
// import VueRaven, { Raven } from 'vue-raven'
import App from './App.vue'
import router from './router'

Vue.config.performance = process.env.NODE_ENV === 'development'
Vue.config.productionTip = false

// TODO: Raven
// Vue.use(VueRaven, {
//   dsn: 'https://4834e9efbdd1481bb4591254f4ed3bf4@sentry.io/1261812',
//   disableReport: process.env.NODE_ENV !== 'production',
//   config: {
//     environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
//     release: process.env.VUE_APP_VERSION || 'dev',
//     debug: process.env.NODE_ENV !== 'production'
//   }
// })

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
